import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Star } from 'lucide-react';
import { Button } from './ui/button';

export const ReviewCards = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            Review Standees
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Make it effortless for customers to leave reviews and build your online reputation across platforms
          </p>
        </div>
      <div className="grid lg:grid-cols-2 gap-6">
        {/* Left - Purple Card */}
        <div className="bg-purple-custom rounded-[2.5rem] p-12 relative min-h-[500px]">
          <h2 className="text-5xl font-extrabold text-navy mb-6">
            Boost Your Business<br />
            with <span className="text-blue-600">Review Standees</span>
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Make it easy for customers to leave reviews with our professional review standees.
          </p>
          
          {/* Floating review cards */}
          <div className="space-y-4">
            <div className="bg-white rounded-2xl p-4 shadow-lg inline-block">
              <div className="flex gap-1 mb-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <div className="text-6xl font-bold text-navy">4.9</div>
                <div>
                  <div className="flex gap-1 mb-1">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">Google Rating</p>
                  <p className="text-xs text-gray-400">See all our reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Dark Cards */}
        <div className="space-y-6">
          {/* Google Review Standees */}
          <div className="bg-dark-gray rounded-[2.5rem] p-12 min-h-[240px] relative">
            <h3 className="text-4xl font-bold text-white mb-4">
              Google Review<br />
              Standees
            </h3>
            <Button 
              onClick={() => navigate('/shop')}
              className="absolute bottom-8 right-8 bg-white text-navy hover:bg-gray-100 rounded-full px-6 py-3 inline-flex items-center gap-2"
            >
              Get your standee today
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>

          {/* TripAdvisor Review Standees */}
          <div className="bg-dark-gray rounded-[2.5rem] p-12 min-h-[240px] relative">
            <h3 className="text-4xl font-bold text-white mb-4">
              TripAdvisor<br />
              Review Standees
            </h3>
            <Button 
              onClick={() => navigate('/shop')}
              className="absolute bottom-8 right-8 bg-white text-navy hover:bg-gray-100 rounded-full px-6 py-3 inline-flex items-center gap-2"
            >
              Get your standee today
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};
